module.exports = __webpack_public_path__ + "static/img/m_3.92d732c2.jpg";